/* eslint import/no-unresolved: "off" */
/* eslint max-len: "off" */
import HelveticaRomanEOT from '../../assets/fonts/helveticaneueltstdroman.eot';
import HelveticaRomanWOFF from '../../assets/fonts/helveticaneueltstdroman.woff';
import HelveticaLightEOT from '../../assets/fonts/helveticaneueltstdlt.eot';
import HelveticaLightWOFF from '../../assets/fonts/helveticaneueltstdlt.woff';
import HelveticaBoldEOT from '../../assets/fonts/helveticaneueltstdbd.eot';
import HelveticaBoldWOFF from '../../assets/fonts/helveticaneueltstdbd.woff';
import HelveticaMediumEOT from '../../assets/fonts/helveticaneueltstdmd.eot';
import HelveticaMediumWOFF from '../../assets/fonts/helveticaneueltstdmd.woff';
import HelveticaThinEOT from '../../assets/fonts/helveticaneueltstdth.eot';
import HelveticaThinWOFF from '../../assets/fonts/helveticaneueltstdth.woff';
import HelveticaCondensedEOT from '../../assets/fonts/helveticaneueltstdcn.eot';
import HelveticaCondensedWOFF from '../../assets/fonts/helveticaneueltstdcn.woff';
import HelveticaCndBlackEOT from '../../assets/fonts/helveticaneueltstdcnblk.eot';
import HelveticaCndBlackWOFF from '../../assets/fonts/helveticaneueltstdcnblk.woff';
import HelveticaHeavyEOT from '../../assets/fonts/helveticaneueltstdhv.eot';
import HelveticaHeavyWOFF from '../../assets/fonts/helveticaneueltstdhv.woff';
import HelveticaOutlineEOT from '../../assets/fonts/helveticaneueltstdbdou.eot';
import HelveticaOutlineWOFF from '../../assets/fonts/helveticaneueltstdbdou.woff';

/**
 * The fonts object exports @font-face definitions.
 */
const Fonts = {
  helveticaNeueLtStdRoman: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-Roman-Normalized';
      src: url(${HelveticaRomanEOT});
      src: url(${HelveticaRomanWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdLt: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-Lt-Normalized';
      src: url(${HelveticaLightEOT});
      src: url(${HelveticaLightWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdBd: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-Bd-Normalized';
      src: url(${HelveticaBoldEOT});
      src: url(${HelveticaBoldWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdMd: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-Md-Normalized';
      src: url(${HelveticaMediumEOT});
      src: url(${HelveticaMediumWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdTh: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-Th-Normalized';
      src: url(${HelveticaThinEOT});
      src: url(${HelveticaThinWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdCn: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-Cn-Normalized';
      src: url(${HelveticaCondensedEOT});
      src: url(${HelveticaCondensedWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdCnBlk: `
    @font-face {
      font-family: 'HelveticaNeueLTStd-CnBlk-Normalized';
      src: url(${HelveticaCndBlackEOT});
      src: url(${HelveticaCndBlackWOFF}) format('woff');
      font-display: swap;
      font-weight: normal;
      font-style: normal;
    }
  `,
  helveticaNeueLtStdHv: `
    @font-face {
      font-family: "HelveticaNeueLTStd-Hv-Normalized";
      src: url(${HelveticaHeavyEOT});
      src: url(${HelveticaHeavyWOFF}) format('woff');
      font-display: swap;
    }
  `,
  helveticaNeueLtStdBdOu: `
    @font-face {
      font-family: "HelveticaNeueLTStd-BdOu-Normalized";
      src: url(${HelveticaOutlineEOT});
      src: url(${HelveticaOutlineWOFF}) format('woff');
      font-display: swap;
    }
  `,
};

/* @component */
export default Fonts;
